import { client } from './index';

export interface LinkedAccount {
  user_id: number;
  account_id: number;
  /** Nullable: `accounts.name` has no NOT NULL and no presence validation. */
  account_name: string | null;
}

export interface LinkedAccountsResponse {
  accounts: LinkedAccount[];
  /** The account the session is standing on. Null only if the user has no account. */
  current: LinkedAccount | null;
}

export interface SwitchAccountResponse {
  account_id: number;
  account_name: string | null;
}

/**
 * The accounts this identity can move to, and which one it is standing on.
 * Empty when the person operates a single account, which is almost everyone:
 * the selector is not rendered at all.
 */
async function getLinkedAccounts() {
  const response = await client.get<LinkedAccountsResponse>('/account_switches');
  return response.data;
}

/**
 * The server re-checks the link and the feature flag. The user_id we send is an
 * intent, not an authorisation.
 */
async function switchAccount(userId: number) {
  const response = await client.post<SwitchAccountResponse>('/account_switches', {
    user_id: userId,
  });
  return response.data;
}

export const accountSwitchesApi = {
  getLinkedAccounts,
  switchAccount,
};
